import {json} from '../../../core/data-source/json.mapper';

export class LinkedOrderRecord {
    @json()
    drop: boolean;
    @json({jsonName: 'orderId'})
    id: number;

    @json({
        jsonName: 'orderReference',
        value: ''
    })
    name: string;
}
